import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { SemanticICONS } from 'semantic-ui-react';

import { slugify } from '../../../../../../../meta/types/wms/Layer';
import { SidebarItemWrapper } from './SidebarItemWrapper';
import ItemContent from './Content';

export type SidebarListItemProps = {
  content?: string;
  icon: SemanticICONS;
  additionalIcon?: any;
  active: boolean;
  to?: string;
  onClick?: () => void;
  popupContent?: any;
  disabled?: boolean;
};

const SidebarListItem = ({
  content,
  icon,
  additionalIcon,
  active,
  to,
  onClick,
  popupContent,
  disabled = false,
}: SidebarListItemProps) => {
  const Content = useMemo(
    () => (
      <ItemContent
        content={content}
        popupContent={popupContent}
        icon={icon}
        additionalIcon={additionalIcon}
        active={active}
        disabled={disabled}
      />
    ),
    [active, disabled, additionalIcon, icon, content, popupContent],
  );

  return (
    <SidebarItemWrapper
      active={active}
      className="sidebar-list__item"
      data-testid={getTestId(to, content)}
      disabled={disabled}
    >
      {to !== undefined && !disabled ? (
        <Link to={to}>{Content}</Link>
      ) : (
        <span onClick={onClick}>{Content}</span>
      )}
    </SidebarItemWrapper>
  );
};

function getTestId(to?: string, content?: string): string {
  return to ? `nav${to}` : `nav/${slugify(content || '')}`;
}

export default React.memo(SidebarListItem);
